import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon } from 'lucide-react';
export function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  const closeMenu = () => {
    setIsMenuOpen(false);
  };
  const navLinks = [{
    name: 'Home',
    path: '/'
  }, {
    name: 'About',
    path: '/about'
  }, {
    name: 'Case Studies',
    path: '/#case-studies'
  }, {
    name: 'Contact',
    path: '/contact'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-transparent'}`} data-id="element-65">
      <nav className="container mx-auto px-6 py-4 flex justify-between items-center" data-id="element-66">
        <Link to="/" className="text-xl font-display font-semibold text-navy-dark" data-id="element-67">
          Emma Rose
        </Link>
        {/* Desktop Navigation */}
        <div className="hidden md:flex items-center space-x-8" data-id="element-68">
          {navLinks.map(link => <Link key={link.path} to={link.path} className={`text-sm font-medium transition-colors hover:text-coral-dark ${location.pathname === link.path ? 'text-coral-dark' : 'text-navy'}`} data-id="element-69">
              {link.name}
            </Link>)}
        </div>
        {/* Mobile Menu Button */}
        <button className="md:hidden text-navy-dark" onClick={toggleMenu} aria-label={isMenuOpen ? 'Close menu' : 'Open menu'} data-id="element-70">
          {isMenuOpen ? <XIcon size={24} data-id="element-71" /> : <MenuIcon size={24} data-id="element-72" />}
        </button>
      </nav>
      {/* Mobile Menu */}
      {isMenuOpen && <div className="md:hidden bg-white" data-id="element-73">
          <div className="container mx-auto px-6 py-4 flex flex-col space-y-4" data-id="element-74">
            {navLinks.map(link => <Link key={link.path} to={link.path} className={`text-sm font-medium py-2 transition-colors hover:text-coral-dark ${location.pathname === link.path ? 'text-coral-dark' : 'text-navy'}`} onClick={closeMenu} data-id="element-75">
                {link.name}
              </Link>)}
          </div>
        </div>}
    </header>;
}